import Noty from 'noty';
import { renderToStaticMarkup } from 'react-dom/server';
import { CheckCircle, Info, Warning } from '@phosphor-icons/react';

Noty.overrideDefaults({
	layout: 'bottomRight',
	timeout: 50000,
	progressBar: false,
});

const getIcon = (type?: Noty.Type) => {
	let icon;
	switch (type) {
		case 'info':
		case 'information':
			icon = <Info size={15} weight="fill" className="phosphor-icon" />;
			break;
		case 'success':
			icon = <CheckCircle size={15} weight="fill" className="phosphor-icon" />;
			break;
		default:
			icon = <Warning size={15} weight="fill" className="phosphor-icon" />;
			break;
	}

	return renderToStaticMarkup(icon);
};

export const notify = (title: string, text?: string, type?: Noty.Type, _timeout?: number) => {
	let timeout = 2500;
	if (_timeout) {
		timeout = _timeout;
	}
	let t = title;
	if (title && text !== '') {
		t = `<b>${title}</b><br />${text}`;
	}

	switch (type) {
		case 'info':
		case 'information':
		case 'success':
			break;
		default:
			timeout = 5000;
			break;
	}

	new Noty({
		type: type ? type : 'info',
		text: `${getIcon(type)} ${t}`,
		timeout,
	}).show();
};
